import Vue from 'vue'
import VueRouter from 'vue-router'
import GroupSelector from '@/views/GroupSelector'
import GroupDetails from '@/views/GroupDetails'
import { authGuard } from '@/services/auth0/authGuard';
import AddExperiment from "@/views/AddExperiment";

Vue.use(VueRouter);

const routes = [
    {
        name: 'GroupSelector',
        path: '/',
        component: GroupSelector,
        beforeEnter: authGuard,
        meta: {
            title: 'AB Testing Panel - Select Group'
        }
    },
    {
        name: 'GroupDetails',
        path: '/group/:name',
        component: GroupDetails,
        beforeEnter: authGuard,
        meta: {
            title: 'AB Testing Panel - Group details'
        }
    },
    {
        name: 'AddExperiment',
        path: '/addExperiment',
        component: AddExperiment,
        beforeEnter: authGuard,
        meta: {
            title: 'AB Testing Panel - Add Experiment'
        }
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || 'AB Testing Panel'
    next()
})

export default router
